import React from 'react';
import './Technologies.css';

const Technologies = () => {
  return (
    <section id='technologies' className='technologies'>
      <div className='technologies-header'>
        <svg
          width='100'
          height='100'
          viewBox='0 0 280 280'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          className='title-icon title-icon-left'
        >
          <path
            d='M202.857 123.929C202.5 123.215 202.5 122.143 202.143 121.429C211.786 112.857 232.5 107.5 230.714 127.857C255.357 105.357 200.714 72.1432 186.071 96.0718C185.357 95.3575 185 95.0003 184.286 94.6432C187.857 82.1432 203.571 66.0718 212.5 85.0003C222.5 52.8575 157.857 51.7861 157.857 80.3575C157.143 80.0003 156.429 80.0003 155.714 80.0003C152.143 67.8575 157.5 44.6432 175 57.1432C167.857 24.2861 110.714 55.7146 125.357 80.3575C124.643 80.3575 123.929 80.7146 123.214 81.0718C113.929 72.1432 107.143 49.6432 128.571 51.4289C106.071 26.7861 72.5 81.7861 97.1429 96.4289C96.4286 96.7861 96.0715 97.5003 95.3572 98.2146C82.8572 95.0003 66.4286 78.9289 85.7143 70.0003C53.9286 60.0003 52.5 123.215 80 124.643C79.6429 125.357 79.6429 126.429 79.2857 127.143C66.7857 130 45.7143 124.286 57.5 107.5C25.3572 114.643 54.6429 168.929 78.9286 158.215C79.2857 159.286 79.2857 160 79.6429 161.072C70 169.286 50 174.286 51.7857 154.286C27.8572 176.072 78.5715 208.215 95 187.857L97.1429 190C92.5 201.786 78.2143 215 69.6429 197.143C60 227.857 118.929 230.357 123.929 205.357C125 205.715 126.071 206.072 127.143 206.072C128.929 218.572 122.857 236.429 106.786 225.357C113.571 256.786 166.071 229.286 157.857 205.357L161.071 204.286C168.929 214.286 172.5 232.857 153.214 231.072C175 255 206.786 204.286 187.143 187.857L189.286 185.715C201.071 190.357 213.929 204.643 196.429 212.857C227.5 222.5 229.643 161.786 203.571 158.215C203.929 157.143 203.929 156.429 204.286 155.357C216.786 153.215 236.429 158.929 224.643 175.357C257.143 166.786 227.5 111.786 202.857 123.929Z'
            fill='#AEAE9D'
          />
        </svg>
        <h1 className='section-title-brighter'>TECHNOLOGIES</h1>{' '}
        <svg
          width='100'
          height='100'
          viewBox='0 0 280 280'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          className='title-icon title-icon-right'
        >
          <path
            d='M202.857 123.929C202.5 123.215 202.5 122.143 202.143 121.429C211.786 112.857 232.5 107.5 230.714 127.857C255.357 105.357 200.714 72.1432 186.071 96.0718C185.357 95.3575 185 95.0003 184.286 94.6432C187.857 82.1432 203.571 66.0718 212.5 85.0003C222.5 52.8575 157.857 51.7861 157.857 80.3575C157.143 80.0003 156.429 80.0003 155.714 80.0003C152.143 67.8575 157.5 44.6432 175 57.1432C167.857 24.2861 110.714 55.7146 125.357 80.3575C124.643 80.3575 123.929 80.7146 123.214 81.0718C113.929 72.1432 107.143 49.6432 128.571 51.4289C106.071 26.7861 72.5 81.7861 97.1429 96.4289C96.4286 96.7861 96.0715 97.5003 95.3572 98.2146C82.8572 95.0003 66.4286 78.9289 85.7143 70.0003C53.9286 60.0003 52.5 123.215 80 124.643C79.6429 125.357 79.6429 126.429 79.2857 127.143C66.7857 130 45.7143 124.286 57.5 107.5C25.3572 114.643 54.6429 168.929 78.9286 158.215C79.2857 159.286 79.2857 160 79.6429 161.072C70 169.286 50 174.286 51.7857 154.286C27.8572 176.072 78.5715 208.215 95 187.857L97.1429 190C92.5 201.786 78.2143 215 69.6429 197.143C60 227.857 118.929 230.357 123.929 205.357C125 205.715 126.071 206.072 127.143 206.072C128.929 218.572 122.857 236.429 106.786 225.357C113.571 256.786 166.071 229.286 157.857 205.357L161.071 204.286C168.929 214.286 172.5 232.857 153.214 231.072C175 255 206.786 204.286 187.143 187.857L189.286 185.715C201.071 190.357 213.929 204.643 196.429 212.857C227.5 222.5 229.643 161.786 203.571 158.215C203.929 157.143 203.929 156.429 204.286 155.357C216.786 153.215 236.429 158.929 224.643 175.357C257.143 166.786 227.5 111.786 202.857 123.929Z'
            fill='#AEAE9D'
          />
        </svg>
      </div>
      <div className='technologies-body'>
        <div className='tech-stack'>
          <h2>
            <span className='normal'>m</span>
            <span className='normal'>y</span>
            <span className='space'> </span>
            <span className='normal'>t</span>
            <span className='normal'>e</span>
            <span className='normal'>c</span>
            <span className='normal'>h</span>
            <span className='space'> </span>
            <span className='bold'>s</span>
            <span className='bold'>t</span>
            <span className='bold'>a</span>
            <span className='bold'>c</span>
            <span className='bold'>k</span>
            <span className='bold'>.</span>
          </h2>
          <p>
            I am always striving to stay up-to-date with the latest technologies
            and trends in software development. With a solid understanding of
            various tech stacks, I focus on selecting the best tools for each
            project to ensure efficiency, scalability, and performance.
            Currently, I am enjoying working with <strong>Next.js</strong>,
            especially for its powerful server-side rendering capabilities,
            which enhance the speed and SEO of modern web applications.
          </p>
        </div>
        <div className='tech-list-container'>
          <div className='tech-section'>
            <ul>
              <li>JavaScript</li>
              <li>HTML</li>
              <li>CSS</li>
            </ul>
          </div>

          <div className='tech-section'>
            <ul>
              <li>React</li>
              <li>Next.js</li>
              <li>Tailwind</li>
              <li>Postgres</li>
              <li>Figma</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Technologies;
